module.exports = __webpack_public_path__ + "static/media/isabel.e7db8833.jpg";